import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Tabs, Tab, Paper, Typography, useTheme, alpha } from '@mui/material';
import {
  AccountBalance as AccountBalanceIcon,
  LibraryBooks as LibraryBooksIcon,
  Paid as PaidIcon,
  Payment as PaymentIcon,
  BarChart as BarChartIcon,
  LocalAtm as LocalAtmIcon,
  ImportExport as ImportExportIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

const FinanceLayout: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();
  
  // التحقق مما إذا كنا في صفحة سند متخصص أو صفحة كشف حساب
  const isSpecializedVoucherPage = location.pathname.includes('/specialized-vouchers/');
  const isAccountStatementsPage = location.pathname.includes('/account-statements');
  
  // Define tabs and their routes
  const tabs = [
    { label: 'الحسابات العامة', icon: <AccountBalanceIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/accounts' },
    { label: 'دفتر الأستاذ العام', icon: <LibraryBooksIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/ledger' },
    { label: 'سندات القبض', icon: <PaidIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/receipts' },
    { label: 'سندات الصرف', icon: <PaymentIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/payments' },
    { label: 'المعاملات', icon: <LocalAtmIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/transactions' },
    { label: 'التقارير المالية', icon: <BarChartIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/reports' },
    { label: 'التصدير والاستيراد', icon: <ImportExportIcon sx={{ mr: 1 }} fontSize="small" />, path: '/finance/export-import' },
  ];
  
  // Find the current active tab index
  const activeTabIndex = tabs.findIndex(tab => location.pathname.startsWith(tab.path)) || 0;

  return (
    <Box sx={{ width: '100%' }}>
      {/* عرض القائمة العلوية فقط إذا لم نكن في صفحة سند متخصص أو صفحة كشف حساب */}
      {!isSpecializedVoucherPage && !isAccountStatementsPage && (
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            border: '1px solid',
            borderColor: alpha('#000', 0.08),
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
            <Tabs
              value={activeTabIndex}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: '#30c3b0',
                  height: 3,
                },
                '& .MuiTab-root': {
                  minHeight: 64,
                  textTransform: 'none',
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  color: theme.palette.text.secondary,
                  '&.Mui-selected': {
                    color: '#30c3b0',
                    fontWeight: 600,
                  },
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {tab.icon}
                      {tab.label}
                    </Box>
                  }
                  component={Link}
                  to={tab.path}
                />
              ))}
            </Tabs>
          </Box>
        </Paper>
      )}
      
      <Outlet />
    </Box>
  );
};

export default FinanceLayout;